import { IconSvg, IconSvgProps } from "./icon"

export default function Copy(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M17.833 8.877h2.14a.778.778 0 0 1 .777.778v10.889a.778.778 0 0 1-.778.777H9.083a.778.778 0 0 1-.777-.777v-2.14" />
      <path d="M3.25 4.6a.778.778 0 0 1 .778-.779h10.889a.778.778 0 0 1 .777.778v10.889a.777.777 0 0 1-.777.778H4.027a.778.778 0 0 1-.777-.778V4.599Z" />
    </IconSvg>
  )
}
